var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sns_login_wrap mr22",on:{"click":function($event){return _vm.googleSignIn()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }